import { Injectable } from '@angular/core';
import {ParentService} from '../../A2-utils/ParentClass/ParentService';
import {Http} from '@angular/http';
import {constant} from '../../../app.constants';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ApprovalTripService  extends ParentService {

  constructor(private _http: Http) {
    super();
  }

  public getPaymentDeniedReason() {
    return this._http.get(constant.URL_PAYMENT_DENIED_REASON, this.getHeader())
      .map(resp => resp.json());
  }

  public putTripPayment(data) {
    return this._http.put(constant.URL_PAYMENT, data,  this.headerPost())
      .map(resp => resp.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public postAppealClaim(data) {
    return this._http.post(constant.URL_CLAIM_APPEAL, data,  this.headerPost())
      .map(resp => resp.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/approval-trip/approval-trip.service.ts